var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "navbar-toggler",
      attrs: { "data-toggle": "collapse", "data-target": "#" + _vm.toggleID }
    },
    [
      _c("span", { staticClass: "sr-only" }, [_vm._v("Toggle navigation")]),
      _c("span", { staticClass: "icon-bar" }),
      _c("span", { staticClass: "icon-bar" }),
      _c("span", { staticClass: "icon-bar" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }